export function inputTheme(theme, { getColor }) {
  return {
    getCSS: ({ targetElement, variant, prefix, suffix, color, isValid, type, iconSize, border, disabled }) => {
      const hasPrefix = ['commaNumeric', 'numeric', 'decimal'].includes(variant) && prefix;
      const hasSuffix = ['commaNumeric', 'numeric', 'decimal'].includes(variant) && suffix;

      const hasIcon = ['email'].includes(type);

      const affixColor = !disabled ? theme.colors.black : theme.colors.neutrals.t400;

      switch (targetElement) {
        case 'inputContainer': {
          return {
            position: 'relative',
            fontSize: theme.fontSizes[1],
            fontWeight: theme.fontWeights.medium,
            lineHeight: theme.lineHeights[2],
            fontFamily: theme.fonts.body,
            ...(hasPrefix && {
              '::before': {
                content: `"${prefix}"`,
                position: 'absolute',
                top: '13px',
                left: theme.space[4],
                color: affixColor,
              },
            }),
            ...(hasSuffix && {
              '::after': {
                content: `"${suffix}"`,
                position: 'absolute',
                top: '13px',
                right: theme.space[4],
                color: affixColor,
              },
            }),
          };
        }

        case 'iconContainer': {
          return {
            ...(hasIcon && {
              position: 'absolute',
              top: '12px',
              left: theme.space[3],
              '& svg': {
                fill: affixColor,
              },
            }),
          };
        }

        case 'input': {
          const focusStyle = {
            outline: 0,
            borderRadius: theme.radii[1],
            borderColor: theme.colors.midBlue.t1000,
            borderStyle: 'Solid',
            borderWidth: theme.borderWidths[0],
          };

          const errorStyle = {
            outline: 0,
            borderRadius: theme.radii[1],
            borderColor: theme.colors.conditional.negative.graphics,
            borderStyle: 'Solid',
            borderWidth: theme.borderWidths[0],
          };

          return {
            boxSizing: 'border-box',
            width: '100%',
            height: '48px',
            margin: 0,
            paddingTop: 0,
            paddingBottom: 0,
            fontSize: 'inherit',
            fontWeight: 'inherit',
            lineHeight: 'inherit',
            fontFamily: 'inherit',
            color: theme.colors.black,
            backgroundColor: getColor(color),
            border,
            borderRadius: theme.radii[1],
            paddingLeft: hasPrefix
              ? `calc(${theme.space[4]} + ${prefix.length + 1}ch)`
              : hasIcon
              ? `calc(${theme.space[3]} + ${iconSize} + ${theme.space[3]})`
              : theme.space[4],
            paddingRight: hasSuffix ? `calc(${theme.space[4]} + ${suffix.length + 1}ch)` : theme.space[4],
            ':focus': isValid && focusStyle,
            ...(!isValid && errorStyle),
          };
        }

        default: {
          return null;
        }
      }
    },
  };
}
